<template>
  <div class="about abouts wpp vdegfdhfs">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="发布主题">
        <el-input v-model="form.name" maxlength="100"></el-input>
      </el-form-item>
      <el-form-item label="发布类型">
        <el-select v-model="form.region" placeholder="请选择发布模块">
          <el-option label="团体发布" value="2"></el-option>
        </el-select>
        <span style="margin-left: 10px;margin-top: 10px;position: absolute;top: 0px;color: rgba(158, 158, 158, 1);">
          单次发布有统计图表，多次发布没有统计图表
        </span>
      </el-form-item>
      <el-form-item label="年级">
        <el-select v-model="form.EntryDate" multiple collapse-tags placeholder="请选择年级">
          <el-option v-for="item in gradedata" :key="item.dicKey" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始指导语" prop="StartGuidelines">
        <el-input type="textarea" v-model="form.StartGuidelines" maxlength="2000" style="wdith: 200px;" show-word-limit>
        </el-input>
      </el-form-item>
      <el-form-item label="结束指导语" prop="FinishGuidelines">
        <el-input type="textarea" v-model="form.FinishGuidelines" maxlength="2000" show-word-limit></el-input>
      </el-form-item>
      <div class="cover">
        <span>封面设计</span>
        <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action=""
          :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <p>
          作为发布内容封面，建议采用比例16:9，大小不超过2M;支持jpg、png格式。如果不填写则设置为默认图
        </p>
        <div class="cctp" @click="cctp">删除图片</div>
      </div>
      <div class="scale0">
        <span>发布对象</span>
        <ul v-for="item in jsonArray2" :key="item.message">
          <li>
            <span :title="item">{{ item }}</span>
            <i @click="drawerss" class="el-icon-close"></i>
          </li>
        </ul>
        <el-button @click="drawerss" plain style="margin-left: 415px; position: absolute; top: 0px; left: 10px;">
          选择对象
        </el-button>
        <el-drawer title="我是标题" class="cldrawer" :visible.sync="drawer0" :with-header="false">
          <div class="scale_list">
            <el-input class="scale_right_input"
              style="width: 50% !important;margin-left: 20px;margin-top: 30px;margin-right: 20px;" v-model="DeptName"
              placeholder="输入发布对象查询" :clearable="true"></el-input>
            <el-button type="primary" @click="querydep">查询</el-button>
            <el-button @click="confirm" type="primary">确定</el-button>
            <el-tree class="dept-tree" ref="myTree" :data="data" @check-change="check" @node-expand="nodeExpand"
              v-model="checkboxGroup222" show-checkbox node-key="DeptID" :default-checked-keys="murenxianshi">
            </el-tree>
          </div>
        </el-drawer>
      </div>
      <div class="scale">
        <span>测试量表</span>
        <ul v-for="item in jsonArray" :key="item.message">
          <li>
            <span :title="item.name">{{ item.name }}</span>
            <i @click="del(item.code)" class="el-icon-close"></i>
          </li>
        </ul>
        <el-button @click="drawer = true" plain style="margin-left: 430px; position: absolute; top: 0px; left: 0px;">
          打开量表
        </el-button>
        <el-drawer class="scale_right" title="我是标题" :visible.sync="drawer" :with-header="false">
          <div class="scale_right_div">
            <h2>选择量表</h2>
            <span>(已选择<i>{{ scalenum }}</i>条)</span>
          </div>
          <el-input class="scale_right_input"
            style="width: 50% !important;margin-left: 20px;margin-top: 30px;padding-right: 20px;"
            v-model="formInline.user" placeholder="输入量表名称搜索"></el-input>
          <el-button type="primary" @click="query">查询</el-button>
          <el-button type="primary" @click="query2">确定</el-button>
          <div class="scale_list" style="height: 77%;">
            <el-tabs :tab-position="tabPosition">
              <el-tab-pane class="cvde" style="text-align: left !important;" v-for="item in scalelist"
                :key="item.message" :label="item.PaperName">
                <el-checkbox-group v-model="checkboxGroup1" v-for="(item, index) in item.LiPaper" :key="index" size="small">
                  <el-checkbox @change="checkedAllFun" :label="item.PaperCode" :name="item.PaperName">
                    {{ item.PaperName }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-drawer>
      </div>
      <el-form-item label="使用别名" style="margin-top: 20px;">
        <el-radio v-model="form.radio" :label="1">是</el-radio>
        <el-radio v-model="form.radio" :label="0">否</el-radio>
      </el-form-item>
      <div class="set_time">
        <h2 class="about_h2_t">
          <i></i>
          <span>时间设置</span>
        </h2>
        <span>有效时间</span>
        <div class="block">
          <el-date-picker @change="chooseTimeRange" value-format="yyyy-MM-dd" v-model="times" unlink-panels
            type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </div>
      </div>
      <div class="set_time">
        <h2 class="about_h2_t" style="margin-top: 20px;">
          <i></i>
          <span>{{ $t('original.languages441') }} </span>
        </h2>
        <div style="height: 190px;padding-top: 10px">
          <el-steps direction="vertical" :active="form.status>3?form.status-4:form.status-1">
            <el-step :title="form.status == 1 ? '风险监控员(审核中)':form.status == 4 ? form.riskMonitor+'(审核驳回)':form.riskMonitor+'(审核通过)'"
                     :description="form.riskMonitorCheckTimeStr"></el-step>
            <el-step :title="(form.status == 1 || form.status == 4)?'危机主管':form.status == 2?'危机主管(审核中)':form.status == 5?form.criAdmin+'(已驳回)':form.criAdmin+'(审核通过)'"
                     :description="form.criAdminCheckTimeStr"></el-step>
            <el-step :title="form.status == 3?'中心主任(审核中)':form.status == 6?form.centerDirector+'(已驳回)':form.status == 7?form.centerDirector+'(审核通过)':'中心主任'"
                     :description="form.centerDirectorCheckTimeStr"></el-step>
          </el-steps>
        </div>
      </div>
      <el-form-item style="margin-top: 40px; margin-left: 20px;">
        <el-button type="primary" :disabled="disableds" @click="onSubmit">立即修改</el-button>
        <el-button @click="wcancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      gradedata:[],
      disableds:false,
      pddj: false, //判断确实按钮是否点击
      imageUrl: '',
      file: '',
      murenxianshi: [],
      param: '',
      Back_num: '',
      DeptName: '',
      drawer: false,
      drawer0: false,
      uny: false,
      scalenum: '0',
      scalelist: '',
      checkboxGroup1: [],
      checkboxGroup222: [],
      checkboxGroup333: [],
      chec: {},
      tabPosition: 'left',
      radio: 1,
      value1: '',
      times: [],
      jsonArray: [], //测试量表显示数组
      jsonArray2: [], //发布对象显示数组
      jsonArray3: [], //发布对象提交数组
      excessive: [], //发布对象显示过度数组
      excessive2: [], //发布对象提交过度数组
      zonglist: [],
      data: [],
      formInline: {
        user: '',
      },
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      form: {
        EntryDate: [],
        name: '',
        radio: 0,
        radio2: 0,
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        StartGuidelines: '',
        FinishGuidelines: '',
      },
    }
  },
  beforeCreate() {
    this.$Http_Post('ScaleIssue/GetShowScale', { Tiaojian: '' }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.scalelist = res.Data
      }
    })
  },
  methods: {
    getSimpleCheckedNodes(store) {// 定义数组
      const checkedNodes = []// 判断是否为全选，若为全选状态返回被全选的节点，不为全选状态正常返回被选中的节点
      const traverse = function (node) {
        const childNodes = node.root ? node.root.childNodes : node.childNodes
        childNodes.forEach(child => {
          if (child.checked) {
            checkedNodes.push(child.data)
          }
          if (child.indeterminate) {
            traverse(child)
          }
        })
      }
      traverse(store)
      return checkedNodes
    },
    check(a, check, checkState) {//部门点击事件
      this.pddj = true
      this.zonglist = this.getSimpleCheckedNodes(this.$refs.myTree.store);
    },
    nodeExpand(dt, obj, node) {
      let allNodes = this.$refs.myTree.getCheckedNodes();
      let _this = this;
      if (dt.fuzi && dt.children.length > 0 && dt.children[0].DeptID == '-1') {
        dt.children = [{ label: '数据加载中...' }]
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt.DeptID, content: '' }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            if (res.Data) {
              dt.children = res.Data
              setTimeout(() => {
                if (obj.checked) {
                  dt.children.forEach((item) => {
                    allNodes.push(item)
                  })
                  this.$refs.myTree.setCheckedNodes(allNodes)
                }
              }, 50)
            }
          }
        })
      }
    },
    cctp() {
      this.imageUrl = '';
      this.file = '';
    },
    handleChange(file, fileList) { },
    query() {
      this.$Http_Post('ScaleIssue/GetShowScale', {
        Tiaojian: this.formInline.user,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.scalelist = res.Data
        }
      })
    },
    query2() {
      this.drawer = false
    },
    querydep() {//部门查询
      this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', DeptName: this.DeptName, }).then((res) => {
        if (res.Code == 200 || res.Code == 0 && res.Data) {
          this.data = res.Data
        }
      })
    },
    drawerss(DeptName) {
      this.drawer0 = true
    },
    del(code) {
      var slist = this.checkboxGroup1
      var i = 0
      for (i = 0; i < slist.length; i++) {
        if (slist[i] == code) {
          slist.splice(i, 1)
        }
      }
      var ss = this.jsonArray
      var ii = 0
      for (ii = 0; ii < ss.length; ii++) {
        if (ss[ii].code == code) {
          ss.splice(ii, 1);
        }
      }
    },
    getSimpleCheckedNodes(store) {// 定义数组
      const checkedNodes = []// 判断是否为全选，若为全选状态返回被全选的节点，不为全选状态正常返回被选中的节点
      const traverse = function (node) {
        const childNodes = node.root ? node.root.childNodes : node.childNodes;
        childNodes.forEach((child) => {
          if (child.checked) {
            checkedNodes.push(child.data);
          }
          if (child.indeterminate) {
            traverse(child);
          }
        })
      }
      traverse(store);
      return checkedNodes;
    },
    confirm() {//部门点击确定
      if (this.pddj) {
        this.drawer0 = false
        this.jsonArray2 = []
        this.jsonArray3 = []
        for (var i = 0; i < this.zonglist.length; i++) {
          var uncss = {}
          this.jsonArray2.push(this.zonglist[i].label)
          this.jsonArray3.push(this.zonglist[i].DeptID)
        }
      } else {
        this.drawer0 = false;
      }
    },
    dealwith() {
      var newArr = []
      for (var i = 0; i < this.checkboxGroup333.length; i++) {
        if (newArr.indexOf(this.checkboxGroup333[i]) === -1) {
          newArr.push(this.checkboxGroup333[i]);
        }
      }
    },
    getCheckedKeys() { },
    wcancel() {
      this.$router.push('PublishedTeam');
    },
    checkedAllFun(string, number, boolean) {
      if (string) {
        var uncs = {};
        uncs.name = number.target.name;
        uncs.code = number.target.value;
        this.jsonArray.push(uncs);
      } else {
        var ss = this.jsonArray;
        var i = 0;
        for (i = 0; i < ss.length; i++) {
          if (ss[i].name == number.target.name) {
            ss.splice(i, 1);
          }
        }
      }
      this.scalenum = this.checkboxGroup1.length
    },
    onSubmit() {
      this.disableds = true;
      let item = {}
      item.fbTheme = this.form.name; //发布主题
      item.fbModule = this.form.region; //发布主题
      item.fbCover = ''; //封面设置
      item.fbObject = this.jsonArray3; //部门
      item.fbScale = this.checkboxGroup1; //发布对象3
      item.fbTime = this.times; //有效时间
      item.fbPublishID = this.param;
      var from = new FormData();
      from.append('IsNickName', this.form.radio);
      from.append('EntryDate', this.form.EntryDate);
      from.append('Nation', this.form.radio2);
      from.append('fbCover', this.file.raw);
      from.append('fbTheme', this.form.name);
      from.append('fbModule', this.form.region);
      from.append('fbObject', this.jsonArray3);
      from.append('fbScale', this.checkboxGroup1);
      from.append('fbTime', this.times);
      from.append('fbPublishID', this.param);
      from.append('StartGuidelines', this.form.StartGuidelines);
      from.append('FinishGuidelines', this.form.FinishGuidelines);
      from.append('token', this.$cookies.get('token'));
      this.$Http_Post('ScaleIssue/UpScale', from).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$notify({ title: '成功', message: res.Message, type: 'success', });
          this.disableds = false;

          this.$router.go(-1)
        } else {
          this.$notify.error({ title: '错误', message: res.Message })
        }
      })
    },
    open() {
      this.$notify.success({
        title: 'Info',
        message: '这是一条没有关闭按钮的消息',
        showClose: false,
      })
    },
    chooseTimeRange(t) {
      this.times = t
    },
    agreeChange(e) {
      if (this.radio == 2) {
        this.s_time = true
      } else {
        this.s_time = false
      }
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    handleChange(file, fileList) {
      this.imageUrl = URL.createObjectURL(file.raw)
      this.file = file
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 8
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
  },
  created() {
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 1 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.gradedata = res.Data
      }
    })
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: '', }).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        this.data = res.Data
      }
    })
    if (this.$route.query.param) {
      this.param = this.$route.query.param
      this.$Http_Post('ScaleIssue/GetScalefb', {
        PublishID: this.$route.query.param,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          var cs = res.Data.PublishedPaper;
          this.form.name = res.Data.PublishSubject;
          this.form.region = res.Data.Type;
          this.times.push(res.Data.ValidStartDate);
          this.times.push(res.Data.ValidEndDate);
          this.imageUrl = res.Data.Coverurl;
          this.form.StartGuidelines = res.Data.StartGuidelines;
          this.form.FinishGuidelines = res.Data.FinishGuidelines;
          this.form.radio = res.Data.IsNickName;
          this.form.radio2 = res.Data.Nation;
          this.form.EntryDate = res.Data.GradeList;
          this.form.status = res.Data.status;
          this.form.riskMonitor = res.Data.riskMonitor;
          this.form.riskMonitorCheckTimeStr = res.Data.riskMonitorCheckTimeStr;
          this.form.criAdmin = res.Data.criAdmin;
          this.form.criAdminCheckTimeStr = res.Data.criAdminCheckTimeStr;
          this.form.centerDirector = res.Data.centerDirector;
          this.form.centerDirectorCheckTimeStr = res.Data.centerDirectorCheckTimeStr;
          var kcs = []
          for (var i = 0; i < res.Data.SSing.length; i++) {
            var uncss = {}
            uncss.name = res.Data.SSing[i][0]
            this.jsonArray3.push(res.Data.SSing[i][1])
          }
          if (res.Data.PublishedPerson) {
            for (var i = 0; i < res.Data.PublishedPerson.length; i++) {
              this.jsonArray2.push(res.Data.PublishedPerson[i].Name)
            }
          }
          for (var i = 0; i < res.Data.PublishedPaper.length; i++) {
            var uncss = {}
            uncss.name = res.Data.PublishedPaper[i].PaperName
            uncss.code = res.Data.PublishedPaper[i].PaperID
            this.jsonArray.push(uncss)
            this.checkboxGroup1.push(res.Data.PublishedPaper[i].PaperID)
          }
          this.scalenum = this.jsonArray.length
        }
      })
    }
  },
}
</script>
<style>
.vdegfdhfs {
  border: 1px solid #e7e7e7;
  min-height: 95%;
  padding: 16px;
  position: relative;
  background-color: #fff;
}
.vdegfdhfs .el-tabs__content{padding-bottom: 40px;}
.about_h2 {
  font-size: 16px;
  position: relative;
}

.about_h2 span {
  position: absolute;
  top: 0px;
  left: 8px;
}

.vdegfdhfs .about_h2_t {
  font-size: 16px;
  position: relative;
  margin-top: 50px;
}

.about_h2_t span {
  position: absolute;
  top: 0px;
  left: 8px;
}

.about_h2_t i {
  height: 20px;
  width: 3px;
  background-color: rgba(42, 143, 232, 1);
  display: inline-block;
}

.about_h2 i {
  height: 20px;
  width: 3px;
  background-color: rgba(42, 143, 232, 1);
  display: inline-block;
}

.vdegfdhfs .el-form .el-input {
  width: 218px !important;
}

.vdegfdhfs form {
  margin-top: 30px;
}

.vdegfdhfs .el-form-item__content {
  position: relative;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.vdegfdhfs .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.vdegfdhfs .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 215px;
  height: 148px;
  line-height: 148px;
  text-align: center;
  border: 1px solid #d1d1d1;
}

.vdegfdhfs .avatar {
  width: 215px;
  height: 148px;
  display: block;
}

.vdegfdhfs .cover {
  margin-left: 10px;
  font-size: 14px;
  vertical-align: middle;
  box-sizing: border-box;
  position: relative;
  color: #606266;
  height: 250px;
}

.vdegfdhfs .avatar-uploader {
  position: absolute;
  top: 0px;
  left: 90px;
}

.vdegfdhfs .cover p {
  font-size: 14px;
  color: rgba(158, 158, 158, 1);
  position: absolute;
  top: 0px;
  left: 320px;
  width: 350px;
}

.scale {
  margin-top: 30px;
}

.scale,
.scale0 {
  margin-left: 10px;
  font-size: 14px;
  vertical-align: middle;
  box-sizing: border-box;
  position: relative;
  color: #606266;
}

.scale ul,
.scale0 ul {
  width: 200px;
}

.scale>ul,
.scale0>ul {
  padding: 5px 12px;
  width: 298px;
  background-color: rgba(235, 235, 235, 1);
  border-radius: 2px;
  margin-top: -20px;
  margin-left: 90px;
}

.scale>ul li,
.scale0>ul li {
  background-color: #fff;
  height: 40px;
  line-height: 40px;
  text-align: left;
  margin-top: 8px;
  margin-bottom: 8px;
  position: relative;
  text-indent: 10px;
  position: relative;
}

.scale>ul li i,
.scale0>ul li i {
  float: right;
  margin-right: 14px;
  margin-top: 14px;
  position: absolute;
  top: 0px;
  right: -5px;
}

.scale>ul li span,
.scale0>ul li span {
  width: 90%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inherit;
}

.set_time>span {
  font-size: 14px;
  color: #606266;
  margin-left: 16px;
  padding-top: 14px;
  display: inline-block;
}

.set_time .block {
  margin-top: -28px;
  margin-left: 90px;
}

.set_time .el-radio {
  float: left;
  margin-top: 20px;
}

.se_time {
  position: relative;
}

.vdegfdhfs .el-radio-group {
  margin-left: 80px;
  margin-top: 0px;
}

.vdegfdhfs .time_picker {
  position: absolute;
  top: 44px;
  left: 172px;
}

.scale_list>ul {
  margin-left: 20px;
  margin-top: 200px;
  position: relative;
}

.scale_list>ul>li {
  height: 40px;
  width: 140px;
  line-height: 40px;
  text-align: left;
}

.scale_list>ul>li ul {
  position: absolute;
  left: 200px;
}

.scale_right h2 {
  font-size: 18px;
  margin-left: 20px;
  margin-top: 60px;
  display: inline-block;
}

.scale_right_div span {
  color: rgba(0, 136, 255, 1);
  margin-left: 10px;
}

.scale_right_div i {
  font-style: normal;
}

.scale_right_div .scale_right_input {
  margin-left: 20px;
  margin-top: 40px;
  width: 180px !important;
  padding-right: 20px;
}

.scale .scale_list {
  margin-top: 50px;
}

.scale .el-tabs--left .el-tabs__item .is-left {
  text-align: left !important;
}

.vdegfdhfs .el-checkbox {
  margin-top: 12px;
  height: 30px;
}

.scale0 .el-tree {
  margin-left: 16px;
  margin-top: 40px;
}

.el-drawer.rtl {
  -webkit-animation: rtl-drawer-out 0.3s;
  animation: rtl-drawer-out 0.3s;
  right: 0;
  width: 40% !important;
}

.cldrawer {
  height: calc(100% - 40px);
}

.dept-tree {
  margin-bottom: 20px;
}

.vdegfdhfs .el-textarea__inner {
  width: 100%;
}

.vdegfdhfs .el-form-item__label {
  width: 100px !important;
}

.vdegfdhfs .textarea {
  margin-left: 20px;
}

.vdegfdhfs .el-form-item__content {
  margin-left: 100px !important;
}

.vdegfdhfs {
  border: 1px solid #e7e7e7;
  min-height: 95%;
  padding: 16px;
  position: relative;
  background-color: #fff;
}

.about_h2 {
  font-size: 16px;
  position: relative;
}

.about_h2 span {
  position: absolute;
  top: 0px;
  left: 8px;
}

.vdegfdhfs .about_h2_t {
  font-size: 16px;
  position: relative;
  margin-top: 50px;
}

.about_h2_t span {
  position: absolute;
  top: 0px;
  left: 8px;
}

.about_h2_t i {
  height: 20px;
  width: 3px;
  background-color: rgba(42, 143, 232, 1);
  display: inline-block;
}

.about_h2 i {
  height: 20px;
  width: 3px;
  background-color: rgba(42, 143, 232, 1);
  display: inline-block;
}

.vdegfdhfs .el-form .el-input {
  width: 218px !important;
}

.vdegfdhfs form {
  margin-top: 30px;
}

.vdegfdhfs .el-form-item__content {
  position: relative;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.vdegfdhfs .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.vdegfdhfs .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 215px;
  height: 148px;
  line-height: 148px;
  text-align: center;
  border: 1px solid #d1d1d1;
}

.vdegfdhfs .avatar {
  width: 215px;
  height: 148px;
  display: block;
}

.vdegfdhfs .cover {
  margin-left: 10px;
  font-size: 14px;
  vertical-align: middle;
  box-sizing: border-box;
  position: relative;
  color: #606266;
  height: 250px;
}

.vdegfdhfs .avatar-uploader {
  position: absolute;
  top: 0px;
  left: 90px;
}

.vdegfdhfs .cover p {
  font-size: 14px;
  color: rgba(158, 158, 158, 1);
  position: absolute;
  top: 0px;
  left: 320px;
  width: 350px;
}

.scale {
  margin-top: 30px;
}

.scale,
.scale0 {
  margin-left: 10px;
  font-size: 14px;
  vertical-align: middle;
  box-sizing: border-box;
  position: relative;
  color: #606266;
}

.scale ul,
.scale0 ul {
  width: 200px;
}

.scale>ul,
.scale0>ul {
  padding: 5px 12px;
  width: 298px;
  background-color: rgba(235, 235, 235, 1);
  border-radius: 2px;
  margin-top: -20px;
  margin-left: 90px;
}

.scale>ul li,
.scale0>ul li {
  background-color: #fff;
  height: 40px;
  line-height: 40px;
  text-align: left;
  margin-top: 8px;
  margin-bottom: 8px;
  position: relative;
  text-indent: 10px;
  position: relative;
}

.scale>ul li i,
.scale0>ul li i {
  float: right;
  margin-right: 14px;
  margin-top: 14px;
  position: absolute;
  top: 0px;
  right: -5px;
}

.scale>ul li span,
.scale0>ul li span {
  width: 90%;
  overflow: hidden;
  /*超出部分隐藏*/
  white-space: nowrap;
  /*不换行*/
  text-overflow: ellipsis;
  /*超出部分文字以...显示*/
  display: inherit;
}

.set_time>span {
  font-size: 14px;
  color: #606266;
  margin-left: 16px;
  padding-top: 14px;
  display: inline-block;
}

.set_time .block {
  margin-top: -28px;
  margin-left: 90px;
}

.set_time .el-radio {
  float: left;
  margin-top: 20px;
}

.se_time {
  position: relative;
}

.vdegfdhfs .el-radio-group {
  margin-left: 80px;
  margin-top: 0px;
}

.vdegfdhfs .time_picker {
  position: absolute;
  top: 44px;
  left: 172px;
}

.scale_list>ul {
  margin-left: 20px;
  margin-top: 200px;
  position: relative;
}

.scale_list>ul>li {
  height: 40px;
  width: 140px;
  line-height: 40px;
  text-align: left;
}

.scale_list>ul>li ul {
  position: absolute;
  left: 200px;
}

.scale_right h2 {
  font-size: 18px;
  margin-left: 20px;
  margin-top: 60px;
  display: inline-block;
}

.scale_right_div span {
  color: rgba(0, 136, 255, 1);
  margin-left: 10px;
}

.scale_right_div i {
  font-style: normal;
}

.scale_right_div .scale_right_input {
  margin-left: 20px;
  margin-top: 40px;
  width: 180px !important;
  padding-right: 20px;
}

.scale .scale_list {
  margin-top: 50px;
}

.scale .el-tabs--left .el-tabs__item .is-left {
  text-align: left !important;
}

.vdegfdhfs .el-checkbox {
  height: 30px;
}

.scale0 .el-tree {
  margin-left: 16px;
  margin-top: 40px;
}

.el-drawer.rtl {
  -webkit-animation: rtl-drawer-out 0.3s;
  animation: rtl-drawer-out 0.3s;
  right: 0;
  width: 40% !important;
}

.cldrawer {
  height: calc(100% - 40px);
}

.dept-tree {
  margin-bottom: 20px;
}

.vdegfdhfs .el-textarea__inner {
  width: 100%;
}

.vdegfdhfs .el-form-item__label {
  width: 100px !important;
}

.vdegfdhfs .textarea {
  margin-left: 20px;
}

.vdegfdhfs .el-form-item__content {
  margin-left: 100px !important;
}

/* .el-form-item__content{margin-left: 100% !important;} */
.vdegfdhfs .el-textarea .el-input__count {
  bottom: -9px;
  background-color: transparent;
}

.vdegfdhfs .el-textarea {
  width: 600px !important;
}

.cctp {
  position: absolute;
  top: 50px;
  left: 322px;
  color: rgba(158, 158, 158, 1);
}

.vdegfdhfs .el-textarea__inner {
  height: 120px;
}

/*审批流程样式*/
.el-step.is-vertical .el-step__title {
  font-size: 14px;
  line-height: 24px;
  padding-bottom: 8px;
}
.el-step.is-vertical .el-step__line {
  width: 2px;
  top: 20px;
  bottom: 0;
  left: 11px;
}
.el-step__icon-inner {
  display: none;
}
.el-step__icon.is-text {
  border-radius: 50%;
  border: 4px solid;
  border-color: inherit;
}
.el-step__icon {
  position: relative;
  z-index: 1;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  top:0px;
  left: 8px;
  width: 8px;
  height: 8px;
}
.examine .paperList {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.el-step__title.is-finish {
  color: #666;
}
.el-step__description.is-finish {
  color: #999;
}
.el-step__head.is-finish {
  border-color: #666;
}

.el-step__title.is-process {
  font-weight: 700;
  color: #0088ff;
}
.el-step__description.is-process {
  color: #999;
}
.el-step__head.is-process {
  border-color: #0088ff;
}
</style>
